/**
 * Get configs and constants from backend and store it.
 * We use store, because we do not want to request again.
 */
import type { ConfigModel } from '/#/models/configModel'

import difference from 'lodash-es/difference'
import merge from 'lodash-es/merge'
import { defineStore } from 'pinia'

import { store } from '/@/store'

export const useConfigStore = defineStore('config', () => {
  const configs = ref<ConfigModel>({})

  async function fetchConfig(config: string[]) {
    const diff = difference(config, Object.keys(configs.value))
    // It means, We are not requested these configs yet.

    if (diff.length > 0) {
      const ret = await configApi(diff)
      // Merge old and new configs.
      configs.value = merge(configs.value, ret)

      // If includes modules, we need to request modules.
      if (diff.includes('modules')) {
        const modules = { modules: await modulesListApi() }
        configs.value = merge(configs.value, modules)
      }
    }
  }

  return { fetchConfig, configs } as const
})

// Need to be used outside the setup
export function useConfigStoreWithout() {
  return useConfigStore(store)
}
